<template>
  <div class="flex items-center mt-4">
    <input :value="value" type="checkbox" class="hidden" />
    <div
      class="
        flex
        items-center
        justify-center
        w-8
        h-8
        border border-dark
        rounded-md
        cursor-pointer
      "
      :class="{ 'bg-primary border-none': value, 'opacity-50': readonly }"
      v-on="events"
    >
      <IconCheck v-if="value" />
    </div>
    <label class="ml-3 cursor-pointer" v-on="events">
      <slot />
    </label>
  </div>
</template>

<script lang="ts">
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import IconCheck from '@/components/IconCheck.vue';
@Component({
  components: {
    IconCheck,
  },
})
export default class CheckboxField extends Vue {
  @Model('change', { type: Boolean }) value!: boolean;

  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  private get events(): { [key: string]: () => void } | {} {
    return !this.readonly
      ? { click: () => this.$emit('change', !this.value) }
      : {};
  }
}
</script>
